import { render } from "./DatetimeFormatter.vue?vue&type=template&id=a4ad0f30"
import script from "./DatetimeFormatter.vue?vue&type=script&lang=js"
export * from "./DatetimeFormatter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__